import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Discover",
      description: "Gain visibility into your AI ecosystem with automated scanning"
    },
    {
      number: "02",
      title: "Evaluate",
      description: "Simulate real-world attacks on your AI applications through continuous red teaming"
    },
    {
      number: "03",
      title: "Remediate",
      description: "Get actionable insights to fix issues before deployment"
    }
  ];

  return (
    <section className="py-24 bg-gray-800 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold">How It Works</h2>
        </div>
        
        <div className="flex flex-col md:flex-row justify-center items-center md:space-x-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center mb-12 md:mb-0">
              <div className="text-8xl font-bold text-gray-700 opacity-60 mb-4">{step.number}</div>
              <h3 className="text-2xl font-bold mb-3">{step.title}</h3>
              <p className="text-gray-400 max-w-xs">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;